import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      "data-clazz": _vm.model.clazz
    }
  }, [_c("div", {
    staticClass: "panelTitle"
  }, [_vm._v(_vm._s(_vm.i18n["messageEvent"]))]), _c("div", {
    staticClass: "panelBody"
  }, [_c("DefaultDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["messageEvent.message"]) + "：")]), _c("el-select", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      placeholder: _vm.i18n["messageEvent.message"],
      value: _vm.model.message,
      disabled: _vm.readOnly
    },
    on: {
      change: function change(e) {
        _vm.onChange("message", e);
      }
    }
  }, _vm._l(_vm.messageDefs, function (message) {
    return _c("el-option", {
      key: message.id,
      attrs: {
        label: message.name,
        value: message.id
      }
    });
  }), 1)], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v("步骤：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.step,
      placeholder: "请输入步骤"
    },
    on: {
      input: function input(value) {
        _vm.onChange("step", value);
      }
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };